export enum DictionaryTypes {
  Icd10 = 'Icd10',
  Icpc2 = 'Icpc2',
  Inn = 'Inn',
  Achi = 'Achi',
  LaboratoryServices = 'LaboratoryServices',
  Questionnairies = 'Questionnairies',
  Morion = 'Morion',
  GeneralRecommendations = 'GeneralRecommendations',
  Substances = 'Substances',
  MorionSubstances = 'MorionSubstances',
  DobrobutServices = 'DobrobutServices',
  EhealthDrugs = 'EhealthDrugs',
  Drugs = 'Drugs',
}
